import React from 'react'

import Form from 'react-bootstrap/Form'

const PROMOTIONAL_DESCRIPTION_MAX = 320

export default function PromotionalDescription({
  value,
  onChange,
  isDisabled = false,
}) {
  return (
    <Form.Group className="form-group" controlId="promotionalDescription">
      <Form.Label>Promotional description</Form.Label>
      <p className="text-muted mb-2">
        Shown on the ticket homepage under this game so fans can spot themes,
        giveaways, specialty jerseys, and other special activities.
      </p>
      <Form.Control
        as="textarea"
        rows={3}
        name="promotionalDescription"
        maxLength={PROMOTIONAL_DESCRIPTION_MAX}
        disabled={isDisabled}
        placeholder="Pink Night. Free bobblehead for the first 1,000 fans. Throwback jerseys."
        value={value || ''}
        onChange={onChange}
      />
    </Form.Group>
  )
}
